
define('text!modules/shared/templates/chartLoader.html',[],function () { return '<div class="loader-holder no-display">\n  <div class="loader-block"></div>\n  <strand-loader class="loader">\n    <label>requesting chart data ...</label>\n  </strand-loader>\n</div>\n';});

